import React, { useContext, useEffect } from 'react'
import { Heading } from 'monday-ui-react-core'
import { Buildings } from 'react-bootstrap-icons'
import { Row } from 'react-bootstrap'
import { StatementContext } from 'utils/context/StatementsContext'
import { StatementCard } from 'components/StatementCard'
import { LoadingSpinner } from 'components/LoadingSpinner'

const SenderReceiverDashboard = () => {
    const {
        isFetchingSenderSummary,
        senderStatements,
        getSenderStatementsSummary
    } = useContext(StatementContext)

    const renderSenderStatementCard = (senderStatementData) => {
        // const urlWhenClicked = receiverStatementData.documentDescription.replace("Statements", "").trim().toLowerCase().replace(" ","-")
        return senderStatementData.companySummaryList.map(companySummary => (
            <StatementCard
                key={companySummary.name}
                statementInfo={{
                    senderNumber : companySummary.senderNumber, 
                    documentType: senderStatementData.documentType,
                    documentDescription: senderStatementData.documentTypeDescription,
                    amountAllStatements: companySummary.amountAllStatements ?? 0,
                    amountStatementsCurrentMonth: companySummary.amountStatementsCurrentMonth ?? 0,
                    companyName: companySummary.name,
                    canUploadFile: companySummary.canUploadFile,
                    //urlWhenClicked
                }}
                cardType="sender"
            />
        ))
    }

    useEffect(() => {
        getSenderStatementsSummary()
    }, [])

    return (
        <div className="container-cards">
            <Heading className="mb-0" value="Sent Statements" />
            <p className="tile-click-text">Click a tile to view the documents.</p>
            {
                isFetchingSenderSummary ? (
                    <LoadingSpinner />
                ) : (
                    senderStatements !== null ?
                    senderStatements.map((senderStatementData, i) => (
                        <div key={i}>
                            <div className="d-flex justify-content-start align-items-center mt-1">
                                <Buildings
                                    className="title-icon border-rounded-circle"
                                    size={17}
                                />
                                <Heading
                                    type={Heading.types.h3}
                                    value={senderStatementData.documentTypeDescription}
                                    ellipsis={false}
                                    className="pt-1 mb-0 ms-2"
                                />
                            </div>
                            <Row>
                                {
                                    senderStatementData.companySummaryList.length && renderSenderStatementCard(senderStatementData)
                                }
                            </Row>
                        </div>
                    ))
                    : undefined
                )
            }
        </div>
    )
    
}

export default SenderReceiverDashboard